export default __webpack_public_path__ + "static/HOS Logo-e016afbcc5e0d6a33a02df42336e9977.png";